import {FC} from "react";
import Navbar from "../../common/Navbar/Navbar";
import Layout from "../../common/layouts/Layout";
import MeetingList from "./MeetingList/MeetingList";

const Meeting: FC = (): JSX.Element => {
    return (
        <Layout>
            <>
                <Navbar pageTitle="Meeting" />
                <MeetingList/>
            </>
        </Layout>
    )
}

export  default Meeting;